import React from "react";
import LoginLink from "./LoginLink";
import { VariantProps } from ".";
import PlusShippingLevels from "../PlusShippingLevels";
import GoogleViewPrice from "../GoogleViewPrice";
import StandardPrice from "../StandardPrice";
const B = (props: VariantProps) => {
  const {
    price,
    unitOfMeasure,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
    hasWebPlusDiscountedShipping,
    allowWebPlusDiscountedShipping,
    isWebstaurantPlusEligible,
    isGoogleView,
    minimumBuy,
    mustBuy,
    user
  } = props;
  return <div className="map map-override mapB" data-sentry-component="B" data-sentry-source-file="B.tsx">
      {isGoogleView ? <GoogleViewPrice price={price.price} minimumBuy={minimumBuy} mustBuy={mustBuy} /> : <StandardPrice price={price.price} unitOfMeasure={unitOfMeasure} />}
      <PlusShippingLevels hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} user={user} data-sentry-element="PlusShippingLevels" data-sentry-source-file="B.tsx" />
      {showBelowMinimumAdvertisedPriceForLoggedInCustomers && <>
          <p className="price enter-email">
            <LoginLink>Login</LoginLink>
            {" for details"}
          </p>
        </>}
    </div>;
};
export default B;